import dayjs from 'dayjs';
import {
  boxTurmaInformacaoStore
} from '../../store/box-turma-informacao.store';
import { useTranslation } from 'react-i18next';

export default function useBoxDataTurmaDetalhe() {
  const { t } = useTranslation(['gestao_de_aulas']);
  const {
    boxTurmaInformacao: {
      quantidadeAulasRealizadas,
      dataInicio,
      dataFim,
      duracaoCompletada,
      quantidadeAlunos,
      duracaoTotal,
      curriculo,
    },
  } = boxTurmaInformacaoStore();
const totalAulasRealizadasLabel =
    quantidadeAulasRealizadas > 1
      ? t('gestao_de_aulas:lessonsCompletedPlural')
      : t('gestao_de_aulas:lessonsCompletedSingular');

  const getDataInicio = dayjs(dataInicio).format('DD/MM/YYYY');
  const getDataFim = dayjs(dataFim).format('DD/MM/YYYY');
  const duracaoEmDias = dayjs(dataFim).diff(dataInicio, 'day');
  const labelDuracao =
    duracaoEmDias > 1
      ? t('gestao_de_aulas:daysPlural')
      : t('gestao_de_aulas:daysSingular');

  const labelAlunos =
    quantidadeAlunos > 1
      ? t('gestao_de_aulas:studentsPlural')
      : t('gestao_de_aulas:studentsSingular');

  const labelMinutos =
    duracaoTotal > 1
      ? t('gestao_de_aulas:minutesPlural')
      : t('gestao_de_aulas:minutesSingular');

  const curriculoTurma = curriculo?.descricaoCurriculo;

  return {
    totalAulasRealizadas: quantidadeAulasRealizadas,
    totalAulasRealizadasLabel,
    getDataInicio,
    getDataFim,
    duracaoEmDias,
    labelDuracao,
    labelAlunos,
    duracaoCompletada,
    labelMinutos,
    curriculoTurma,
    curriculo,
  };
}
